var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rightPanelContainer"},[_vm._t("content",function(){return [_vm._v("content")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }